import CoverageTerm from './CoverageTerm';
import FIMenuLeaseTerm from './FIMenuLeaseTerm';
import FIMenuLoanTerm from './FIMenuLoanTerm';

export interface IFIMenuPaymentAmount {
	amountFinanced?: number;
	buyRate?: number;
	coverageTerm?: number;
	dealTerm?: FIMenuLoanTerm | FIMenuLeaseTerm;
	paymentAtBuyRate?: number;
	paymentAtBuyRateWithTax?: number;
	paymentAtSellRate?: number;
	paymentAtSellRateWithTax?: number;
	reserveProfitFlat?: number;
	reserveProfitSplit?: number;
	sellRate?: number;
}

export default class FIMenuPaymentAmount {
	amountFinanced?: number = null;
	buyRate?: number = null;
	coverageTerm?: number = null;
	dealTerm?: FIMenuLoanTerm | FIMenuLeaseTerm = null;
	paymentAtBuyRate?: number = null;
	paymentAtBuyRateWithTax?: number = null;
	paymentAtSellRate?: number = null;
	paymentAtSellRateWithTax?: number = null;
	reserveProfitFlat?: number = null;
	reserveProfitSplit?: number = null;
	sellRate?: number = null;

	constructor(init?: IFIMenuPaymentAmount) {
		if (init) {
			this.amountFinanced = init.amountFinanced;
			this.dealTerm = init.dealTerm;
			this.coverageTerm = init.coverageTerm;
			this.sellRate = this.isValidRate(init);
			this.paymentAtSellRate = init.paymentAtSellRate;
			this.paymentAtSellRateWithTax = init.paymentAtSellRateWithTax;
			this.buyRate = init.buyRate;
			this.paymentAtBuyRate = init.paymentAtBuyRate;
			this.paymentAtBuyRateWithTax = init.paymentAtBuyRateWithTax;
			this.reserveProfitFlat = init.reserveProfitFlat;
			this.reserveProfitSplit = init.reserveProfitSplit;
		}
	}
	/// if rate does not meet validation results in zero for reserve profit
	isValidRate(init: IFIMenuPaymentAmount) {
		return init.sellRate >= init.buyRate ? init.sellRate : init.buyRate;
	}
}
